import {
  ICoordinateSystemInfoProvider,
  ScaleInfo,
  ScaleManager,
  T_ScaleManager,
} from '@cgs/common';
import {
  Container,
  RasterizerDescription,
  RasterizerState,
  Rect,
  RenderContext,
  SceneObject,
  Vector2,
} from '@cgs/wge';
import { ResourcesComponent } from '../game/components/resources_component';
import { T_ISlotGame, RESOURCES_COMPONENT_TOKEN } from '../type_definitions';
import { IReelsConfig } from './i_reels_config';
import { ISlotGame } from './i_slot_game';
import { IconInfo, IconsSceneObject } from './icons_scene_object';

export class IconsSceneObjectWithScissor extends IconsSceneObject {
  private coordinateProvider: ICoordinateSystemInfoProvider;
  private gameNode: SceneObject;
  private iconsHolder: SceneObject;
  private scaleInfo: ScaleInfo;
  private canvasScale: Vector2;

  private rootMode: SceneObject;

  constructor(
    drawWithPushState: boolean,
    container: Container,
    reelsConfig: IReelsConfig,
    coordinateProvider: ICoordinateSystemInfoProvider
  ) {
    super(drawWithPushState, container, reelsConfig);

    this.coordinateProvider = coordinateProvider;
    this.gameNode = container.resolve<ISlotGame>(T_ISlotGame).gameNode;
    this.iconsHolder = this.gameNode.findById('icons_holder')!;

    const resourceComponent = container.resolve<ResourcesComponent>(RESOURCES_COMPONENT_TOKEN);
    this.rootMode = resourceComponent.root.findById<SceneObject>('Modes')!.parent!;

    const scaleManager = container.resolve<ScaleManager>(T_ScaleManager);

    scaleManager.scaler.addScaleChangedListener((info: ScaleInfo) => {
      this.scaleInfo = info;
      this.canvasScale = new Vector2(
        this.coordinateProvider.canvas.width / this.coordinateProvider.coordinateSystem.width,
        this.coordinateProvider.canvas.height / this.coordinateProvider.coordinateSystem.height
      );
    });

    scaleManager.scaler.invalidate();
  }

  applyRasterizerState(iconInfo: IconInfo, _context: RenderContext): void {
    const icon = iconInfo.icon;

    if (iconInfo.lineIndex < 0) {
      return;
    }

    const holderId = `icon_holder_${iconInfo.reelIndex}_${iconInfo.lineIndex}`;

    let holder = this.gameNode.findById(holderId);

    if (!holder) {
      holder = new SceneObject();
      holder.id = holderId;
      holder.size = this.reelsConfig.symbolSize.clone();

      holder.position = iconInfo.position.clone();

      this.iconsHolder!.addChild(holder);
    }

    const newSize = this.scaleInfo.scale
      .multiply(holder.size)
      .multiply(this.canvasScale)
      .multiply(this.rootMode.scale);

    const holderWorldPos = this.coordinateProvider.transformToGlobalPosition(holder.worldTransform);

    const description = new RasterizerDescription();

    const size = Rect.fromSize(
      new Vector2(
        holderWorldPos.x,
        this.coordinateProvider.canvas.height - holderWorldPos.y - newSize.y
      ),
      newSize.clone()
    );

    description.scissocTestEnable = true;
    description.viewPortEnable = false;

    description.scissor = size;
    icon.rasterState = new RasterizerState(description);
  }
}
